<script>

	import 'flatpickr/dist/flatpickr.css'
    
    import Moment from 'moment'
    import Flatpickr from 'svelte-flatpickr'

    export let label = ''
    export let value = Moment().startOf('day').toDate()
    
    export let minDate = null
    export let maxDate = null
    export let showTime = false

    const options = {
        minDate,
        maxDate,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        enableTime: showTime,
        dateFormat: "Y-m-d H:i"
    }

</script>

<div class="field">
    {#if label}
        <label for="" class="label">{ label }</label>
    {/if}
    <div class="control">
        <Flatpickr {options} bind:value on:change />
    </div>
</div>